import Vue from 'vue'

const actions = {

  /**
   *
   * @param context
   * @param newNetworkId {integer}
   */
  async changeNetwork (context, newNetworkId) {
    await Vue.axios.post('/user/chooseNetwork', { Network: newNetworkId })
    context.commit('SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading devices...')
    context.dispatch('selectNetwork', newNetworkId)
    context.dispatch('Medium/clearList', {}, { root: true })
    context.dispatch('File/clearList', {}, { root: true })
    if (this.state.User.user.skin !== 'onlyOwnMedia') await context.dispatch('Device/loadData', {}, { root: true })
    context.commit('Device/CLEAR_TAG_FILTER', 'left', { root: true })
    context.commit('Device/CLEAR_TAG_FILTER', 'right', { root: true })
    context.commit('Request/SET_REQUESTS_FAILED_LIST', [], { root: true })

    Vue.$io.socket.off('LOST_HB')
    Vue.$io.socket.on('LOST_HB', data => {
      if (!this.state.User.liveMode.heartbeat) return
      context.commit('Device/LOST_HB', data, { root: true })
    })
    Vue.$io.socket.off('RECOVERED_HB')
    Vue.$io.socket.on('RECOVERED_HB', data => {
      if (!this.state.User.liveMode.heartbeat) return
      context.commit('Device/RECOVERED_HB', data, { root: true })
    })
    if (this.state.Device.device_list.length < 500) {
      console.log('ENABLING LIVE MODE')
      context.dispatch('User/setLiveMode', {
        heartbeat: true,
        contentUpdateProgress: true,
        contentPending: true,
        failedRequests: true,
        mediaConvertions: true,
        screenshots: true,
        library: true
      }, { root: true })
    } else {
      console.log('DISABLING LIVE MODE')
      context.dispatch('User/setLiveMode', {
        heartbeat: false,
        contentUpdateProgress: false,
        contentPending: false,
        failedRequests: false,
        mediaConvertions: false,
        screenshots: true,
        library: false
      }, { root: true })
    }
    Vue.$io.socket.off('user_network_change')
    Vue.$io.socket.on('user_network_change', data => {
    //   // it's network change from another browser/tab from same user, so reload here
      if (data.userId === this.state.User.user.id && this.state.User.user.lastNetworkId !== data.networkId) {
        window.location.reload()
      }
    })
  },
  setLiveMode (context, liveMode) {
    context.commit('SET_LIVE_MODE', liveMode)
  },
  addNetworkToAdminNetworks (context, newNetwork) {
    context.commit('ADD_ADMIN_NETWORK', newNetwork)
  },
  async getPackageVersion (context) {
    try {
      const resp = await Vue.axios.get('user/getPackageVersion')
      context.commit('SET_PACKAGE_VERSION', resp.data)
      return resp.data
    } catch (error) {
      context.commit('SET_PACKAGE_VERSION', undefined)
      return undefined
    }
  },
  /**
   *
   * @param context
   * @param actualNetworkId {integer}
   */
  async selectNetwork (context, actualNetworkId) {
    const previousNetwork = context.state.user.lastNetworkId
    context.commit('SET_NETWORK_STATUS', true)
    context.commit('SET_LAST_NETWORK_ID', actualNetworkId)
    Vue.$io.socket.post(`/sockets/joinNetworkStatuses?joiningNetwork=${actualNetworkId}&leavingNetwork=${previousNetwork}`, function (body, JWR) {})
    context.dispatch('getNetworkUsers')
  },
  async getNetworkUsers (context) {
    context.commit('SET_USERLIST_NETWORK', (await Vue.axios.get('user/getUsersWithNetworkPermission')).data)
  },
  async sendBroadcastMessage (context, data) {
    await Vue.axios.post('sockets/sendBroadcastMessage', data, { disableResponseInterceptors: true })
  },
  lastNetworkId (context, lastNetworkId) {
    context.commit('SET_LAST_NETWORK_ID', lastNetworkId)
  },

  setAuthProviders(context, providers) {
    context.commit('SET_AUTH_PROVIDERS', providers);
  },

  async getAuthProviders(context) {
    if (context.state.providers.length) {
      return context.state.providers
    }

    const resp = await Vue.axios.get('user/me', {
      validateStatus: () => true,
      disableResponseInterceptors: true,
    });

    context.commit("SET_AUTH_PROVIDERS", resp.data.providers)

    return context.state.providers;
  },
  async loginSuccessful (context, { user, userprivileges, csrfToken }) {
    user.userPrivileges = userprivileges
    // Reconnect socket after login to reattach to (possibly) new session
    await Vue.$io.connect()
    context.commit('SET_CSRF_TOKEN', csrfToken)
    context.commit('SET_USER', user)
    if (
      user.Roles.find(role => role.name.indexOf('admin') > -1) &&
      !user.Networks.find(network => network.id === user.lastNetworkId)
    ) {
      await context.dispatch('Network/addAdminNetwork', user.lastNetworkId, { root: true })
    }
    // context.dispatch('selectNetwork', user.lastNetworkId)
    context.dispatch('changeNetwork', user.lastNetworkId)
    console.log('user login successful action')
  },
  logout (context) {
    Vue.axios.post('user/logout')
      .then(() => {
        context.commit('RESET_USER')
        context.dispatch('Device/clearList', {}, { root: true })
        context.dispatch('Medium/clearList', {}, { root: true })
        context.dispatch('File/clearList', {}, { root: true })
      })
    clearInterval(window.wsHealthCheckInterval)
  },
  getData (context) {
    Vue.axios.get('user')
      .then(response => {
        for (let index = 0; index < response.data.length; index++) {
          addUserIdsField(response.data[index])
        }

        context.commit('SET_USERLIST', response.data)
      })
  },
  getMe (context) {
    let path = 'user/me'
    Vue.axios.get(path)
      .then(response => {
        context.commit('SET_USER', response.data)
      })
  },
  async getUserData (context, params) {
    let path = 'user/' + params.data.userId
    let populate = []
    let requestParam

    if (params.options && params.options.populate && !params.options.populate) {
      populate = []
      requestParam = { params: { populate: populate.join(',') } }
    }

    let user = await Vue.axios.get(path, requestParam)
      .then(response => {
        addUserIdsField(response.data)

        context.commit('UPDATE_USER_IN_USERLIST', response.data)
        return JSON.parse(JSON.stringify(response.data))
      })
    return user
  },

  async createUserData (context, params) {
    let response
    params.data.Roles = params.data.RoleIds
    params.data.Client = params.data.ClientId
    params.data.Networks = params.data.NetworkIds

    delete params.data.id
    await Vue.axios.post('user', params.data, { disableResponseInterceptors: true })
      .then(response => {
        addUserIdsField(response.data)

        context.commit('ADD_USER_TO_USERLIST', response.data)
        response = response.data
      })

    return response
  },

  async updateUserData (context, params) {
    let response
    params.data.Roles = params.data.RoleIds
    params.data.Client = params.data.ClientId
    params.data.Networks = params.data.NetworkIds
    params.data.DesktopPlayListsModified = params.data.DesktopPlayListsModifiedIds

    if (params.data.password === '') {
      delete params.data.password
      delete params.data.password2
    }
    await Vue.axios.patch('user/' + params.data.id, params.data, { disableResponseInterceptors: true })
      .then(response => {
        addUserIdsField(response.data)

        context.commit('UPDATE_USER_IN_USERLIST', response.data)
        response = response.data
      })

    return response
  },
  toggleRightPanelChosen (context) {
    context.commit('TOGGLE_RIGHT_PANEL_CHOSEN')
  },
  setRightPanelChosen (context, target) {
    context.commit('SET_RIGHT_PANEL_CHOSEN', target)
  },
  setLeftPanelChosen (context, target) {
    context.commit('SET_LEFT_PANEL_CHOSEN', target)
  },
  setFocusedSide (context, side) {
    context.commit('SET_FOCUSED_SIDE', side)
  },
  setAxiosActiveState (context, axiosActiveState) {
    context.commit('SET_AXIOS_ACTIVE_STATE', axiosActiveState)
  },
  addAxiosActiveRoute (context, route) {
    context.commit('ADD_AXIOS_ACTIVE_ROUTE', route)
  },
  deleteAxiosActiveRoute (context, route) {
    context.commit('DELETE_AXIOS_ACTIVE_ROUTE', route)
  }
}

let addUserIdsField = function (userData) {
  userData.ClientId = userData.Client !== null ? userData.Client.id : null
  userData.NetworkIds = userData.Networks.map(item => item.id)
  userData.RoleIds = userData.Roles.map(item => item.id)

  if (userData.DesktopPlayListsModified) {
    userData.DesktopPlayListsModifiedIds = userData.DesktopPlayListsModified.map(item => item.id)
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/user/user.actions.js
// module id = null
// module chunks = 